import { useSelector } from "react-redux";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import { getSubmissionComplete } from "@redux/selectors/submission-selectors";
import {
    getConfigurationResponseProperties,
    getConfigurationTheme,
    getDontRenderUI,
    getHeadErrorMessage,
    getHeadErrorToFooter,
    getIsPolicyDecisionRetry
} from "@redux/selectors/verification-configuration-selectors";
import {
    getAssertionErrorMessages,
    getShouldRetryVerification,
    getShowAsyncButton
} from "@redux/selectors/verification-form-selectors";
import { PostFormHelpTextContainer } from "../post-form-help-text-container/post-form-help-text-container";
import { FormButtonContainer } from "../../form-button-container/form-button-container";
import { ErrorMessagesContainer } from "../error-messages-container/error-messages-container";
import { FormikErrors } from "formik";

type PostAttributeListContainerProps = {
    isSubmitting: boolean;
    errors: FormikErrors<any>;
    useThemedUI: boolean;
    isValid: boolean;
    hasFinishedTMXProfiling: boolean;
    canShowPolicyDecisionRetryMessage: boolean;
};

export const PostAttributeListContainer = (props: PostAttributeListContainerProps) => {
    const {
        isSubmitting,
        errors,
        useThemedUI,
        isValid,
        hasFinishedTMXProfiling,
        canShowPolicyDecisionRetryMessage
    } = props;

    const properties = useSelector(getConfigurationResponseProperties);
    const showAsyncButton = useSelector(getShowAsyncButton);
    const dontRenderUI = useSelector(getDontRenderUI);
    const theme = useSelector(getConfigurationTheme)
    const content = useSelector(getLanguageContent);
    const isPolicyDecisionRetry = useSelector(getIsPolicyDecisionRetry);
    const showErrorsInFooter = useSelector(getHeadErrorToFooter);
    const headErrorMessage = useSelector(getHeadErrorMessage);
    const shouldRetryVerification = useSelector(getShouldRetryVerification);
    const assertionErrorMessages = useSelector(getAssertionErrorMessages);
    const submissionComplete = useSelector(getSubmissionComplete);

    const showFooterPolicyDecisionRetryError = !submissionComplete && showErrorsInFooter && isPolicyDecisionRetry && canShowPolicyDecisionRetryMessage;
    const showFooterInlineRetryError = shouldRetryVerification && showErrorsInFooter && assertionErrorMessages.length === 0;
    const showFooterAssertionErrors = shouldRetryVerification && showErrorsInFooter && assertionErrorMessages.length > 0;

    return (
        <>
            {showErrorsInFooter && (
                <ErrorMessagesContainer
                    showPolicyDecisionRetryError={showFooterPolicyDecisionRetryError}
                    showInlineRetryError={showFooterInlineRetryError}
                    content={content}
                    theme={theme}
                    useThemedUI={useThemedUI}
                    inlineErrorMessage={headErrorMessage}
                    showAssertionErrors={showFooterAssertionErrors}
                    assertionErrorMessages={assertionErrorMessages}
                />
            )}
            {useThemedUI && <PostFormHelpTextContainer isSubmitting={isSubmitting} />}
            { /** if dontRenderUI is not set - render this component */}
            {!dontRenderUI && (
                <FormButtonContainer
                    useThemedUI={useThemedUI}
                    showAsyncButton={showAsyncButton}
                    pageProperties={properties}
                    hasFinishedTMXProfiling={hasFinishedTMXProfiling}
                    theme={theme}
                    content={content}
                    isSubmitting={isSubmitting}
                    errors={errors}
                    isValid={isValid}
                />
            )}
        </>
    )
};